module.exports = __webpack_public_path__ + "3343229e360dc8553e7d04173a5424fd.jpg";